export function urlProps(url: string) {
    const isExternal = url.startsWith('http');
    const props: { target?: string; href?: string; to?: string } = {};
    if (isExternal) {
        props.target = '_blank';
        props.href = url;
    } else {
        props.to = url;
    }
    return props;
}
